import Vue from 'vue'
import VueI18n from 'vue-i18n'
import moment from 'moment'
import { en, es } from 'vuetify/lib/locale'

Vue.use(VueI18n)

export default new VueI18n({
  // locale: process.env.VUE_APP_I18N_LOCALE || 'es',
  // fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'es',
  locale: 'es-MX',
  fallbackLocale: 'es-MX',
  // messages: loadLocaleMessages()
  messages: {
    en: Object.assign(require('../locales/en.json'), { $vuetify: en }),
    'es-MX': Object.assign(require('../locales/es-MX.json'), { $vuetify: es }),
  },
})

moment.locale('es')
